const getJSONFromLocalStorage = (key:string) => {
  try {
    return JSON.parse(localStorage.getItem(key) || 'null');
  } catch (e) {
    return null;
  }
};

export default getJSONFromLocalStorage;
